module.exports = __webpack_public_path__ + "static/phone-45b32bb88d1854805a82918f8faedd37.jpg";